module.exports = __webpack_public_path__ + "assets/a70dc73ee655d5a7fb8440c3e8c94179.mp4";